import { ExternalPartner } from '@amzn/red-velvet-api';

export const PARTNER_OPTIONS = [
  { value: ExternalPartner.NONE, labelKey: 'teamPartnershipStep.partner_none' },
  { value: ExternalPartner.VISIT, labelKey: 'teamPartnershipStep.partner_visit' },
  { value: ExternalPartner.GOODERA, labelKey: 'teamPartnershipStep.partner_goodera' },
  { value: ExternalPartner.TAPROOT, labelKey: 'teamPartnershipStep.partner_taproot' },
  { value: ExternalPartner.OTHER, labelKey: 'teamPartnershipStep.partner_other' },
] as const;

/** Maximum entries allowed in EventInput.amazonContacts. */
export const MAX_AMAZON_CONTACTS = 5;

/** Maximum additional coordinators allowed on an event (Smithy @length constraint). */
export const MAX_COORDINATORS = 5;
